const agentIndex = {
    path: '/agent/index',
    name: 'agentIndex',
    component: resolve => require(['../../views/agent/index.vue'], resolve),
    meta: { title: '代理人首页',keepActive:true }
};
const agentOrder = {
  path: '/agent/order',
  name: 'agentOrder',
  component: resolve => require(['../../views/agent/order.vue'], resolve),
  meta: { title: '订单列表',keepActive:true }
};
const agentAmount = {
  path: '/agent/amount',
  name: 'agentAmount',
  component: resolve => require(['../../views/agent/amount.vue'], resolve),
  meta: { title: '代理金额',keepActive:true }
};
  export default [agentIndex,agentOrder,agentAmount];


// WEBPACK FOOTER //
// ./src/router/modules/agent.js